import React from 'react';
import { CheckIcon, LayoutGridIcon, ClockIcon, HammerIcon, ShieldCheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { COMMERCIAL_RIGHTS, SERVICE_CARDS } from '../../data/catio';
const CARD_ICONS = [LayoutGridIcon, ClockIcon, HammerIcon];

/** Short business-angle section for builders: 3 uses + commercial build rights. No income claims. */
export function ServiceSection() {
  return <section aria-labelledby="service-title" className="bg-stone py-12 sm:py-20" data-id="element-275" data-mp="28q0nt8f1tc6y">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-276" data-mp="2dnk0w500fixb">
        <SectionHeading id="service-title" eyebrow="For builders & service providers" title="Give Clients More Catio Options. Start with an Existing Design." lead="Use the collection to explore suitable designs with clients and prepare projects around their space, preferences and build requirements." data-id="element-277" data-mp="1yzyy6c71rlpx" />

        <ul className="mt-8 grid gap-3 sm:mt-10 md:grid-cols-3 md:gap-5" data-id="element-278" data-mp="2wgnvbsl1xzsz">
          {SERVICE_CARDS.map((card, index) => {
          const Icon = CARD_ICONS[index] ?? HammerIcon;
          return <li key={card.title} className="flex flex-col rounded-[14px] border border-line bg-paper px-5 py-5 sm:px-6 sm:py-6" data-id="element-279" data-mp="1119z8y5vrv5j" data-mpi={index}>
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-wood-light text-wood" data-id="element-280" data-mp="19zbusy6uhvlf">
                  <Icon className="h-5 w-5" strokeWidth={1.8} aria-hidden data-id="element-281" data-mp="1on6repnz4k3s" />
                </span>
                <h3 className="mt-4 font-display text-[1.35rem] leading-tight text-ink" data-id="element-282" data-mp="1jpor1no0vd7e">
                  {card.title}
                </h3>
                <p className="mt-2 text-[0.95rem] leading-relaxed text-graphite" data-id="element-283" data-mp="1todz6oq49jag">
                  {card.description}
                </p>
              </li>;
        })}
        </ul>

        <div id="commercial-rights" className="mt-5 grid gap-5 rounded-[18px] bg-ink px-5 py-6 text-cream sm:px-8 sm:py-7 md:mt-6 lg:grid-cols-[auto_1fr_1fr] lg:items-center lg:gap-10" data-id="element-284" data-mp="3vfr1d60p9d2t">
          <div className="flex items-center gap-3" data-id="element-285" data-mp="23d4settleqib">
            <ShieldCheckIcon className="h-7 w-7 shrink-0 text-ember-light" strokeWidth={1.7} aria-hidden data-id="element-286" data-mp="23g0rilh6fl8c" />
            <h3 className="font-display text-[1.35rem] leading-tight sm:text-[1.5rem]" data-id="element-287" data-mp="28fdow05ocap6">
              {COMMERCIAL_RIGHTS.title}
            </h3>
          </div>
          <p className="flex items-start gap-2.5 text-[0.95rem] leading-relaxed text-cream/85" data-id="element-288" data-mp="2hcxsvgux8l3h">
            <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-ember-light" strokeWidth={2.5} aria-hidden data-id="element-289" data-mp="2mbhe1f1oxsus" />
            {COMMERCIAL_RIGHTS.allowed}
          </p>
          <p className="flex items-start gap-2.5 text-[0.95rem] leading-relaxed text-cream/70" data-id="element-290" data-mp="2w2c2mq2et4je">
            <XIcon className="mt-1 h-4 w-4 shrink-0 text-cream/50" strokeWidth={2.5} aria-hidden data-id="element-291" data-mp="311yf2xaeygr5" />
            {COMMERCIAL_RIGHTS.notAllowed}
          </p>
        </div>
      </div>
    </section>;
}